import { render, staticRenderFns } from "./QuizPlayer.vue?vue&type=template&id=a2450142&scoped=true"
import script from "./QuizPlayer.vue?vue&type=script&lang=js"
export * from "./QuizPlayer.vue?vue&type=script&lang=js"
import style0 from "./QuizPlayer.vue?vue&type=style&index=0&id=a2450142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2450142",
  null
  
)

export default component.exports